<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1400" scrollable>
    <v-card class="dialog_content">
      <v-card-title class="package-product-title py-2">
        패키지 장비(모델) 정보
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-3">
        <v-layout wrap justify-center>
          <v-card class="ma-1 mt-0" outlined>
            <v-form id="packageMaster">
              <div class="ma-2">패키지 장비(모델) 정보 <span v-if="item_id">{{ item_id }}</span></div>

              <v-layout>
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 140px"
                  id="manufacturer_id"
                  ref="manufacturer_id"
                  label="판매사ID"
                  v-model="manufacturer_id"
                  placeholder="판매사 코드"
                  maxlength="20"
                  clearable
                />
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 200px"
                  id="manufacturer_name"
                  ref="manufacturer_name"
                  label="판매사명✽"
                  v-model="manufacturer_name"
                  placeholder="판매사명"
                  maxlength="50"
                  clearable
                />
              </v-layout>

              <v-layout>
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 140px"
                  id="real_manufacturer_id"
                  ref="real_manufacturer_id"
                  label="제조사ID"
                  v-model="real_manufacturer_id"
                  placeholder="제조사 코드"
                  maxlength="20"
                  clearable
                />
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 200px"
                  id="real_manufacturer_name"
                  ref="real_manufacturer_name"
                  label="제조사명✽"
                  v-model="real_manufacturer_name"
                  placeholder="제조사명 (OEM 등 실제 생산 업체가 다른 경우)"
                  maxlength="50"
                  clearable
                />
              </v-layout>

              <v-autocomplete
                dense
                outlined
                class="ma-1"
                style="height: 45px; width: 350px"
                id="category_type"
                ref="category_type"
                label="장비유형✽"
                v-model="category_type"
                :items="category_typeItems"
                :menu-props="{ top: false, offsetY: true }"
                item-text="name"
                placeholder="장비유형을 선택하세요"
                return-object
                @change="changeCategoryType(category_type)"
              />
              <v-autocomplete
                dense
                outlined
                class="ma-1"
                style="height: 45px; width: 350px"
                id="device_type"
                ref="device_type"
                label="장비코드✽"
                v-model="device_type"
                :items="device_typeItems"
                :menu-props="{ top: false, offsetY: true }"
                item-text="description"
                placeholder="장비코드를 선택하세요"
                @focus="comboDeviceType(true)"
                return-object
                clearable
              />

              <v-layout align-center>
                <v-text-field
                  dense
                  outlined
                  hide-details
                  class="ma-1"
                  style="height: 45px; width: 200px"
                  id="device_name"
                  ref="device_name"
                  label="제품명✽"
                  v-model="device_name"
                  placeholder="제품명"
                  maxlength="50"
                  clearable
                />
                <div class="use-yn-field ma-1">
                  <span class="use-yn-label">사용여부</span>
                  <v-switch
                    v-model="use_yn"
                    hide-details
                    inset
                    color="#3a4f3f"
                    class="mt-0 ml-2"
                    @change="onUseYnChange"
                  />
                </div>
              </v-layout>

              <v-layout>
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 160px"
                  id="manufacturer_model_no"
                  ref="manufacturer_model_no"
                  label="판매사모델번호✽"
                  v-model="manufacturer_model_no"
                  placeholder="판매사모델번호"
                  maxlength="50"
                  clearable
                />
                <v-text-field
                  dense
                  outlined
                  class="ma-1"
                  style="height: 45px; width: 185px"
                  id="real_manufacturer_model_no"
                  ref="real_manufacturer_model_no"
                  label="제조사모델번호✽"
                  v-model="real_manufacturer_model_no"
                  placeholder="제조사모델번호"
                  maxlength="50"
                  clearable
                />
              </v-layout>

              <v-layout>
                <v-menu
                  v-model="menuSetdate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      outlined
                      readonly
                      class="ma-1"
                      style="height: 45px; width: 170px"
                      id="setdate"
                      ref="setdate"
                      label="제품 등록일자"
                      v-model="setdate"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    locale="ko-KR"
                    v-model="setdate"
                    @input="menuSetdate = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  dense
                  outlined
                  readonly
                  class="ma-1"
                  style="height: 45px; width: 170px"
                  id="deldate"
                  ref="deldate"
                  label="제품 중지일자"
                  v-model="deldate"
                  append-icon="mdi-calendar"
                />
              </v-layout>

              <v-textarea
                outlined
                dense
                rows="2"
                name="input-7-4"
                style="height: auto; margin: 5px 3px 0px 5px"
                label="비고"
                id="history"
                ref="history"
                v-model="history"
                value=""
                persistent-hint
                :hint="hint"
              ></v-textarea>

              <v-card-actions class="d-block">
                <v-row justify="center">
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    class="normal-btn mr-2"
                    style="height: 30px; width: 20px; margin-bottom: 15px"
                    :loading="loadingSave"
                    id="save"
                    ref="save"
                    type="submit"
                    @click.prevent="save()"
                  >
                    저장
                  </v-btn>
                  <v-btn
                    rounded
                    class="new-btn mr-2"
                    style="height: 30px; width: 20px; margin-bottom: 15px"
                    id="clear"
                    ref="clear"
                    @click="newRegister()"
                  >
                    새로
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-row>
              </v-card-actions>
            </v-form>
          </v-card>

          <v-card class="ma-1 ml-1 mt-0" outlined style="flex: 1; min-width: 700px;">
            <v-data-table
              dense
              height="550px"
              class="elevation-3 v-data-table"
              style="margin-left: 1px; margin-right: 0px"
              id="items"
              ref="items"
              :loading="loadingList"
              :headers="headers"
              :items="items"
              :items-per-page="50000"
              no-data-text="등록된 자료가 없습니다."
              fixed-header
              hide-default-footer
              @click:row="infoDetail"
              item-key="id"
              :item-class="itemRowBackground"
              single-select
              :value="selectedRows"
              @input="selectedRows = $event"
              :search="search"
            >
              <template v-slot:item.use_status="{ item }">
                {{ item.deldate ? "미사용" : "사용" }}
              </template>
            </v-data-table>

            <v-card-title>
              <v-text-field
                dense
                style="width: 250px"
                class="shrink"
                clearable
                v-model="search"
                append-icon="mdi-magnify"
                label=""
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-card-actions class="justify-center">
              <v-btn
                rounded-pill
                class="elevation-5 ma-3 rounded-pill normal-btn"
                style="height: 35px"
                id="refreshList"
                ref="refreshList"
                @click="refreshList()"
              >
                <v-icon left dark>mdi-refresh</v-icon>
                목록고침
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// TODO: 삭제(delete) API 준비되면 연동 필요 (urls.js에 엔드포인트 추가 후 교체)
import Apis from "@/api/apis";
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

export default {
  name: "PackageProductDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    save_item_id: "",
    selectedRows: [],
    search: "",

    item_id: "",

    manufacturer_id: "",
    manufacturer_name: "",
    real_manufacturer_id: "",
    real_manufacturer_name: "",
    category_type: {},
    category_typeItems: Common.comboBaseCode("EX"),
    Devision_code: "",
    device_type: {},
    device_typeItems: [],
    device_name: "",
    use_yn: true,
    manufacturer_model_no: "",
    real_manufacturer_model_no: "",
    setdate: "",
    deldate: "",
    menuSetdate: false,

    history: "",
    hint: "",

    items: [],
    headers: [
      {
        text: "장비종류",
        align: "left",
        value: "device_type.description",
        sortable: true,
        groupable: false,
        width: "110px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "판매사명",
        align: "left",
        value: "maker_name",
        sortable: true,
        groupable: false,
        width: "130px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "판매사모델",
        align: "left",
        value: "model",
        sortable: true,
        groupable: false,
        width: "140px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제품명",
        align: "left",
        value: "device_name",
        sortable: true,
        groupable: false,
        width: "130px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "판매사ID",
        align: "left",
        value: "maker_id",
        sortable: true,
        groupable: false,
        width: "120px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제조사명",
        align: "left",
        value: "realmaker_name",
        sortable: true,
        groupable: false,
        width: "130px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제조사모델",
        align: "left",
        value: "realmodel",
        sortable: true,
        groupable: false,
        width: "140px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제조사ID",
        align: "left",
        value: "realmaker_id",
        sortable: true,
        groupable: false,
        width: "120px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "장비유형",
        align: "left",
        value: "category_type.description",
        sortable: true,
        groupable: false,
        width: "110px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제품 등록일자",
        align: "left",
        value: "setdate",
        sortable: true,
        groupable: false,
        width: "150px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "제품 중지일자",
        align: "left",
        value: "deldate",
        sortable: true,
        groupable: false,
        width: "150px",
        class: "green darken-4 white--text",
        divider: false,
      },
      {
        text: "사용여부",
        align: "left",
        value: "use_status",
        sortable: true,
        groupable: false,
        width: "110px",
        class: "green darken-4 white--text",
        divider: false,
      },
    ],

    loadingSave: false,
    loadingList: false,
  }),
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.refreshList();
      }
    },
  },
  methods: {
    changeCategoryType(category_type) {
      this.Devision_code = category_type.code.slice(-2);
      this.comboDeviceType();
    },
    comboDeviceType(flag) {
      if (flag && !this.Devision_code) {
        alert("장비유형을 먼저 선택하세요.");
        this.$refs.category_type.focus();
        return;
      }
      Apis.baseCodeList({
        division: this.Devision_code,
        }, (res) => {
          if (res.result) {
            this.device_typeItems = res.data;
          } else {
            this.device_typeItems = [];
            alert(res.message);
          }
        }).catch((err) => {
          console.log("baseCodeList API 호출 오류", err);
          alert(err);
        }
      )
    },
    onUseYnChange(useYn) {
      this.deldate = useYn ? "" : dateUtil.format(new Date(), "yyyy-MM-dd");
    },
    newRegister() {
      this.clearData();
      this.save_item_id = "";
      this.selectedRows = [];
      this.$store.commit(
        "resMessage",
        "새로운 패키지 장비(모델)를 입력할 준비가 되었습니다.",
      );
      this.$refs.manufacturer_id.focus();
    },
    clearData() {
      this.item_id = "";

      this.manufacturer_id = "";
      this.manufacturer_name = "";
      this.real_manufacturer_id = "";
      this.real_manufacturer_name = "";
      this.category_type = {};
      this.Devision_code = "";
      this.device_type = {};
      this.device_name = "";
      this.use_yn = true;
      this.manufacturer_model_no = "";
      this.real_manufacturer_model_no = "";
      this.setdate = "";
      this.deldate = "";

      this.history = "";
      this.hint = "";
    },
    checkData() {
      if (!this.manufacturer_name.trim()) {
        this.$refs.manufacturer_name.focus();
        return "판매사명을 입력하세요";
      }
      if (!this.real_manufacturer_name.trim()) {
        this.$refs.real_manufacturer_name.focus();
        return "제조사명을 입력하세요";
      }
      if (!this.category_type.code) {
        this.$refs.category_type.focus();
        return "장비유형을 선택하세요";
      }
      if (!this.device_type.basecode) {
        this.$refs.device_type.focus();
        return "장비코드를 선택하세요";
      }
      if (!this.device_name.trim()) {
        this.$refs.device_name.focus();
        return "제품명을 입력하세요";
      }
      if (!this.manufacturer_model_no.trim()) {
        this.$refs.manufacturer_model_no.focus();
        return "판매사모델번호를 입력하세요";
      }
      if (!this.real_manufacturer_model_no.trim()) {
        this.$refs.real_manufacturer_model_no.focus();
        return "제조사모델번호를 입력하세요";
      }
      return "";
    },
    buildCommonPayload() {
      return {
        maker_id: this.manufacturer_id,
        maker_name: this.manufacturer_name,
        realmaker_id: this.real_manufacturer_id,
        realmaker_name: this.real_manufacturer_name,
        category_type: this.category_type.code || "",
        device_type: this.device_type.basecode || "",
        device_name: this.device_name,
        model: this.manufacturer_model_no,
        realmodel: this.real_manufacturer_model_no,
        memo: this.history.trim(),
        rsvr1: "",
        rsvr2: "",
        no1: null,
        no2: null,
        setdate: this.setdate,
      };
    },
    save() {
      this.$store.commit("resMessage", "");
      let msgCheckdata = this.checkData();
      if (msgCheckdata) {
        this.$store.commit("resMessage", msgCheckdata);
        return;
      }

      this.loadingSave = true;

      if (this.item_id) {
        const payload = {
          id: this.item_id,
          ...this.buildCommonPayload(),
          deldate: this.deldate,
        };
        Apis.updatePackageProduct(payload, (res) => {
          if (res.result) {
            this.$store.commit("resMessage", res.message);
            this.loadingSave = false;
            this.save_item_id = this.item_id;
            this.clearData();
            this.refreshList();
          } else {
            this.loadingSave = false;
            alert(res.message);
          }
        }).catch((err) => {
          this.loadingSave = false;
          console.log("updatePackageProduct API 호출 오류", err);
          alert(err);
        });
      } else {
        const payload = this.buildCommonPayload();
        Apis.insertPackageProduct(payload, (res) => {
          if (res.result) {
            this.$store.commit("resMessage", res.message);
            this.loadingSave = false;
            this.clearData();
            this.refreshList();
          } else {
            this.loadingSave = false;
            alert(res.message);
          }
        }).catch((err) => {
          this.loadingSave = false;
          console.log("insertPackageProduct API 호출 오류", err);
          alert(err);
        });
      }
    },
    infoDetail(value, row) {
      row.select(true);
      this.$store.commit("resMessage", "");
      this.save_item_id = value.id;

      this.item_id = value.id;
      this.manufacturer_id = value.maker_id;
      this.manufacturer_name = value.maker_name;
      this.real_manufacturer_id = value.realmaker_id;
      this.real_manufacturer_name = value.realmaker_name;
      this.category_type = value.category_type
        ? { code: value.category_type.code, name: value.category_type.description }
        : {};
      this.Devision_code = this.category_type.code ? this.category_type.code.slice(-2) : "";
      this.device_type = value.device_type
        ? { basecode: value.device_type.code, description: value.device_type.description }
        : {};
      this.comboDeviceType();
      this.device_name = value.device_name;
      this.use_yn = !value.deldate;
      this.manufacturer_model_no = value.model;
      this.real_manufacturer_model_no = value.realmodel;
      this.setdate = value.setdate || "";
      this.deldate = value.deldate || "";

      this.history = value.memo || "";
      this.hint = value.chguser
        ? value.chguser + "님이 " + value.chgdate + "에 최종 수정"
        : "";
    },
    refreshList() {
      this.$store.commit("resMessage", "");
      this.loadingList = true;

      Apis.listPackageProducts({}, (res) => {
        if (res.result) {
          this.items = res.data;
        } else {
          this.items = [];
          alert(res.message);
        }
        this.loadingList = false;
      }).catch((err) => {
        console.log("listPackageProducts API 호출 오류", err);
        this.loadingList = false;
      });
    },
    itemRowBackground(item) {
      return item.id == this.save_item_id ? "selected" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog_content {
  padding: 10px;
  border-radius: 30px;
}
::v-deep .v-dialog.v-dialog--active.v-dialog--scrollable {
  border-radius: 30px;
  overflow: hidden;
}
.use-yn-field {
  display: flex;
  align-items: center;
  height: 45px;
  margin-top: -2px !important;
  .use-yn-label {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
  }
  ::v-deep .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  ::v-deep .v-input--selection-controls__ripple {
    margin: 0 !important;
  }
}
.v-data-table::v-deep {
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size: 13px;
      height: 40px !important;
    }
  }
}
.normal-btn,
.search-btn {
  background-color: #3a4f3f !important;
  color: white;
  width: 100px;
  height: 45px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
}
.search-btn {
  height: 40px !important;
  width: 50px !important;
  border-radius: 20px !important;
}
.new-btn {
  color: #3a4f3f !important;
  width: 100px;
  height: 45px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
  background-color: rgb(248, 248, 248) !important;
}
</style>
